import React from 'react';

export const initialsFor = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

interface MemberAvatarProps {
  name: string;
  size?: number;
  title?: string;
  className?: string;
}

const MemberAvatar: React.FC<MemberAvatarProps> = ({
  name,
  size = 24,
  title,
  className,
}) => (
  <span
    className={`member-avatar${className ? ` ${className}` : ''}`}
    title={title ?? name}
    style={{
      width: size,
      height: size,
      fontSize: Math.max(9, Math.round(size * 0.4)),
    }}
  >
    {initialsFor(name)}
  </span>
);

export default MemberAvatar;
